import {
  EDIT_USER
} from '../../actions/actionTypes';
import initialState from '../initialState';

export default (state = initialState.user.edit, action = {type: ''}) => {
    switch (action.type) {
        case EDIT_USER:
            return {
                name: action.payload.name,
                email: action.payload.email,
                enabled: action.payload.enabled,
                deleted: action.payload.deleted,
                paying: action.payload.paying
            };
        default:
            return state;
      }
}



// WEBPACK FOOTER //
// ./src/reducers/userReducer/editUserReducer.js